import React from 'react'
import { NewSearch } from 'meinian-package/src/baseComponent/input'
import Select from 'meinian-package/src/baseComponent/select'
import { SwitchTabBorder } from '../../../components/switchTab'
import styles from './index.module.less'

const inspirationTypeOptions = [{ label: '不限', value: null }, { label: '秀场直击', value: 'runway' }, { label: '社媒潮流', value: 'social' }]

const InspirationType = ({ value, onChange }) => {
  return <Select
    value={value}
    onChange={onChange}
    data={inspirationTypeOptions}
    placeholder="不限"
    allowClear={false}
  />
}

export const Filter = ({ tabAllowClear, options, params, onChange }) => {
  return <div className={styles['mn-recommend-official-inspiration']}>
    <span>
      {
      !!options.length && !inspirationTypeOptions.some(item => item.value === params.queryType) && <SwitchTabBorder
        allowClear={tabAllowClear}
        value={params.queryType}
        options={options}
        onChange={(val) => onChange({ queryType: val })}
      />
    }
    </span>
    <span>
      <InspirationType
        value={params.queryType}
        onChange={(val) => {
          if (val) {
            onChange({ queryType: val })
          } else {
            onChange({ queryType: 'all' })
          }
        }}
      />
      <NewSearch
        wrapClassName="search"
        wrapStyle={{ marginLeft: '24px', width: '216px' }}
        value={params.titleLike}
        // onKeyUp={ev => onChange({ keyWords: ev.target.value })}
        onChange={val => onChange({ titleLike: val })}
        onClear={() => {
          onChange({ titleLike: '' })
        }}
        placeholder="输入关键词搜索官方灵感集"
      />
    </span>
  </div>
}
